import Tool, { type ToolHandler } from '../Tool';
import type { AssistantToolCall } from 'components/framework/models';
import type Agent from '../../agents/Agent';

/**
 * Handler for WhiteboardAgent::CreateWireframeTool
 * Creates wireframes on the whiteboard
 */
const createWireframeToolHandler: ToolHandler = {
  processToolCall(toolCall: AssistantToolCall, agent: Agent): void {
    if (toolCall.content?.data) {
      const { wireframe } = JSON.parse(toolCall.content.data) as any;
      if (agent.contexts.getWhiteboardController) {
        const controller = agent.contexts.getWhiteboardController();
        controller.actionAddGeneratedWireframe(wireframe);
      }
    }
  },

  unavailable(agent: Agent): boolean {
    return !agent.contexts.getWhiteboardController;
  },
};

Tool.register(
  'WhiteboardAgent::CreateWireframeTool',
  createWireframeToolHandler
);
